import type { ObservationEntityRef } from "@/drawing/managers/ObservationsManager";

/**
 * Photos ↔ marqueurs photo du plan.
 *
 * L'association est MANUELLE : les photos sont prises en live sur le terrain,
 * leur nom de fichier ne veut rien dire. C'est l'utilisateur qui désigne, dans
 * le formulaire d'observation, quelle photo illustre quel marqueur
 * (`DiagnosticImage.photoNumber` = numéro du marqueur). Ce module ne porte que
 * la lecture des numéros de marqueurs rattachés à une observation.
 */

/** Numéros de marqueurs d'une observation (entités marqueur rattachées). */
export function observationMarkerNumbers(
  localId: string | null | undefined,
  entitiesByObservation: Map<string, ObservationEntityRef[]>
): number[] {
  if (!localId) return [];
  const refs = entitiesByObservation.get(localId) ?? [];
  return [
    ...new Set(
      refs.map((r) => r.markerNumber).filter((n): n is number => n !== null)
    ),
  ];
}
